<template>
  <div class="not-found">404 Not Found</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
</style>
